<template>
	<div>
		<list-equipments-component :equipment-type="equipmentType" :btn-add-label="FormMSG(64, 'Add generator')" />
	</div>
</template>

<script>
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import { SPE_GENERATOR_TYPE } from '../../../../shared/constants';
import ListEquipmentsComponent from './ListEquipmentsComponent.vue';

export default {
	name: 'ListGenerators',
	components: { ListEquipmentsComponent },

	mixins: [languageMessages, globalMixin],

	data() {
		return {
			equipmentType: SPE_GENERATOR_TYPE
		};
	}
};
</script>
